<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd :title="'Chantiers'" :description="'Nouveau chantier '" />
      </div>
    </div>

    <chantier-form
      v-if="loaded"
      :propForm="form"
      @submit="submit"
      @goList="goList"
      :commerciaux="commerciaux"
      :inspecteurs="commerciaux"
      :clients="clients"
      :societes="societes"
      :periodicites="periodicites"
    />
  </div>
</template>

<script>
import URL from '@/http/chantier';
import ChantierForm from '@/views/chantier/components/ChantierForm.vue';
import names from '@/constants/routes/chantier/chantier';

import From from 'vform';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: new From({
        date: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        nom: '',
        commercial: null,
        societe: null,
        client: null,
        periodicite: null,
        statut: true,
        recurrence: false,
      }),
      loaded: false,
      routes: names,
      commerciaux: [],
      societes: [],
      clients: [],
      periodicites: [],
    };
  },
  components: {
    ChantierForm,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('chantier', ['currentChantier']),
  },
  methods: {
    ...mapActions('chantier', ['setCurrentChantier']),
    init() {
      this.loaded = false;
      window.axios
        .all([window.axios.get(URL.GET_REQUIREMENTS)])
        .then(
          window.axios.spread((resp) => {
            this.commerciaux = resp.data.commerciaux;
            this.clients = resp.data.clients;
            this.societes = resp.data.societes;
            this.periodicites = resp.data.periodicites;
            this.loaded = true;
          })
        )
        .catch();
    },
    submit(form) {
      form
        .post(URL.CHANTIER)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.setCurrentChantier(resp.data.chantier);
          form.reset();
          form.clear();

          this.$router.push({
            name: this.routes.show,
            params: { id: resp.data.chantier.id },
          });
        })
        .catch((err) => {
          form.errors.set('message', err.response.data.message);
        })
        .finally(() => {
          this.form = form;
        });
    },

    goList() {
      this.$router.push({
        name: this.routes.base,
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
